/**
 * Authentication Provider Constants
 * Centralizes all auth provider identifiers and configurations
 */

export const AuthProviders = {
    LDAP: 'ldap',
    PASSWORD: 'password',
    EMAIL_TOKEN: 'email_token',
    GOOGLE: 'google',
    FACEBOOK: 'facebook',
    APPLE: 'apple'
}

/**
 * Provider priority order for auto-selection
 * Higher index = higher priority
 */
export const ProviderPriority = [
    AuthProviders.LDAP,
    AuthProviders.EMAIL_TOKEN,
    AuthProviders.PASSWORD,
    AuthProviders.GOOGLE,
    AuthProviders.FACEBOOK,
    AuthProviders.APPLE
]

/**
 * Social providers list
 */
export const SocialProviders = [
    AuthProviders.GOOGLE,
    AuthProviders.FACEBOOK,
    AuthProviders.APPLE
]

export default AuthProviders
